import colors from "./colors";

const { dark } = colors;

const globals = {
  body: {
    color: colors.dark.main,
    backgroundImage: "radial-gradient(rgb(11 11 12 / 6%) 1.1px, transparent 1.1px)",
    backgroundSize: "20px 20px",
    backgroundPosition: "-10px -10px",
    fontVariantNumeric: "tabular-nums",
  },
  "::selection": { color: colors.dark.main, background: colors.brand.main },
  ":is(a, button, input, select, textarea, [tabindex]):focus-visible": {
    outline: "3px solid #3f5406",
    outlineOffset: "3px",
  },
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${colors.brand.ink} !important`,
  },
};

export default globals;
